import React, { useState, useEffect } from "react";
import "./ListStyles.css";

import { useNavigate } from "react-router-dom";

import useAxios from "./useAxios";

import moment from "moment";

const UserTournamentsList = () => {
  const navigate = useNavigate();
  const [axios] = useAxios(true);

  const [competitions, setCompetitions] = useState([]);

  useEffect(() => {
    axios.get("competitions", setCompetitions);
  }, []);

  return (
    <div className="list-container">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 12,
          marginBottom: 24,
        }}
      >
        <h2 style={{ margin: 0 }}>Tournaments</h2>
      </div>
      <table className="list-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Date/Time</th>
            <th>Type</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {competitions
            .sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime))
            .map((competition) => (
              <tr key={competition.id}>
                <td>{competition.name}</td>
                <td>
                  {moment(competition.dateTime).format("DD/MM/yyyy HH:mm")}
                </td>
                <td>{competition.type?.name}</td>
                <td>
                  <button
                    className="edit-button"
                    onClick={() => navigate("/tournament/" + competition.id)}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserTournamentsList;